var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { classnames } from '../../lib';
import { TablContext } from './TablContext';
const CONTEXT_VALUE = { variant: 'body' };
export const TablBody = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (React.createElement(TablContext.Provider, { value: CONTEXT_VALUE },
        React.createElement("tbody", Object.assign({}, rest, { className: classnames('tabl__body', className) }), children)));
};
//# sourceMappingURL=TablBody.js.map